module.exports = __webpack_public_path__ + "img/HC1038-01.205f5670.jpg";